import React, {useEffect, useState} from 'react';

import {useTranslation} from 'react-i18next';

import {ReactComponent as ClearIcon} from 'assets/svg/cross.svg';
import {searchChanged} from 'models/profile/customsUsers/table';

import {CancelIcon, StyledInput} from './styled';

export const TableSearch = () => {
    const {t} = useTranslation();
    const [isFirstRender, setIsFirstRenter] = useState(true);
    const [value, setValue] = useState('');
    const delay = 1000;

    useEffect(() => {
        if (isFirstRender) {
            setIsFirstRenter(false);
            return;
        }
        const timeoutId = setTimeout(() => {
            searchChanged(value.trim());
        }, delay);
        return () => clearTimeout(timeoutId);
    }, [value, delay]);

    return (
        <StyledInput
            value={value}
            onChange={(event) => setValue(event.target.value ?? '')}
            placeholder={t('pages.customs.search')}
            adornment={
                <CancelIcon
                    width={10}
                    height={10}
                    source={ClearIcon}
                    onClick={() => setValue('')}
                />
            }
        />
    );
};
